import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import ProjectsList from './components/ProjectsList/ProjectsList';

function App() {
  return (
    <div>
      <Header />
      <ProjectsList />
      <Footer />
    </div>
  );
}

export default App;
